import React from 'react';

import styles from '../nuoV2.scss';

const NCSAErrorDisplay = (props) => {
    const { handleRefresh, skipForm, errorCode } = props;

    return (
        <div className={styles.pageContent}>
            <div className={styles.title} data-testid="nuo-v2.ncsa-error.title">
                Something went wrong with your NCSA submission.
            </div>
            <div className={styles.description} data-testid="nuo-v2.ncsa-error.description">
                Please refresh this page and try again. It it still doesn&apos;t work, please contact our <a href="https://support.utrsports.net/support/home" rel="noopener noreferrer" target="_blank" data-testid="nuo-v2.ncsa-error.support-link">support</a>. ({errorCode})
                <br /><br />
                Alternatively, you can click this button to continue to your UTR Sports registration and complete
                the NCSA submission after. We&apos;ll guide you through the process.
            </div>
            <div className="row mt16">
                <button
                    type="button"
                    className="btn btn-primary btn-block btn-lg text-uppercase"
                    onClick={() => handleRefresh()}
                    data-testid="nuo-v2.ncsa-error.refresh-btn"
                >
                    Refresh Page
                </button>
            </div>
            <div className="row mt16">
                <hr className="col-md-3" /> OR <hr className="col-md-3" />
            </div>
            <div className="row mt16">
                <button
                    type="button"
                    className="btn btn-primary btn-block btn-lg text-uppercase"
                    onClick={() => skipForm()}
                    data-testid="nuo-v2.ncsa-error.continue-btn"
                >
                    Continue UT Registration
                </button>
            </div>
        </div>
    );
};

export default NCSAErrorDisplay;
